/* eslint-disable func-style */
import { yodaCustomerConstants } from "../constants";
import { yodaCustomerService } from "../services";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaCustomerActions = {
  getAll,
  getOne,
};

function getAll(agentId, page = 1, pageSize = 10000) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCustomerService.getAll(agentId, page, pageSize).then(
      (response) => {
        if (response?.results != null) {
          const { results } = response;
          dispatch(success(results));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCustomerService.getAll",
      { agentId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCustomerConstants.GETALL_REQUEST };
  }
  function success(customers) {
    return {
      type: yodaCustomerConstants.GETALL_SUCCESS,
      payload: { customers },
    };
  }
  function failure(error) {
    return { type: yodaCustomerConstants.GETALL_FAILURE, payload: { error } };
  }
}

function getOne(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaCustomerService.getOne(id).then(
      (response) => {
        if (
          response !=
          null /* && response.results != undefined && response.results.length > 0 */
        ) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaCustomerService.getOne",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaCustomerConstants.GETONE_REQUEST };
  }
  function success(customer) {
    return {
      type: yodaCustomerConstants.GETONE_SUCCESS,
      payload: { customer },
    };
  }
  function failure(error) {
    return { type: yodaCustomerConstants.GETONE_FAILURE, payload: { error } };
  }
}
